module.exports = __webpack_public_path__ + "img/32.9c5d64ec.png";